import { Typography } from "@mui/material";
import { theme } from "app/App";
import InputBox from "./input/InputBox";

export default function Fieldset({ label, fullWidth, sx, children, ...props }) {
    return (
        <InputBox
            sx={{
                "& fieldset": { flex: 1, border: "1px solid", borderColor: theme.palette.grey[400] },
                "& legend": { pl: 1, pr: 1 },
                flexBasis: fullWidth ? "100%" : null,
                ...sx,
            }}
            {...props}
        >
            <fieldset>
                <legend>
                    <Typography variant="subtitle2">{label}</Typography>
                </legend>

                {children}
            </fieldset>
        </InputBox>
    );
}
